import { Settings } from 'react-slick';

const RESPONSIVE_DEFAULT = [
    {
        breakpoint: 1440, // lg
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
        }
    },
    {
        breakpoint: 1024, // md
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
        }
    },
    {
        breakpoint: 768, // sm
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
        }
    },
    {
        breakpoint: 320, // xs
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }
];

const DEFAULT_CONFIG = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    centerMode: false,
    centerPadding: '20px',
    swipeToSlide: true,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: RESPONSIVE_DEFAULT
};

export const getCarouselConfig = (
    { xl, lg, md, sm, xs, settings }
        : {xl?:number, lg?:number, md?:number, sm?:number, xs?:number, settings: Settings}
) => {
    const responsive = RESPONSIVE_DEFAULT.map((data, index) => {
        if(index === 0 && lg) {
            return {
                ...data,
                settings: {
                    ...data.settings,
                    slidesToShow: lg,
                    slidesToScroll: lg
                }
            };
        }
        if(index === 1 && md) {
            return {
                ...data,
                settings: {
                    ...data.settings,
                    slidesToShow: md,
                    slidesToScroll: md
                }
            };
        }
        if(index === 2 && sm) {
            return {
                ...data,
                settings: {
                    ...data.settings,
                    slidesToShow: sm,
                    slidesToScroll: sm
                }
            };
        }
        if(index === 3 && xs) {
            return {
                ...data,
                settings: {
                    ...data.settings,
                    slidesToShow: xs,
                    slidesToScroll: xs
                }
            };
        }
        return data;
    });
    return {
        ...DEFAULT_CONFIG,
        slidesToShow: xl || DEFAULT_CONFIG.slidesToShow,
        slidesToScroll: xl || DEFAULT_CONFIG.slidesToScroll,
        ...settings,
        responsive
    };
};